import AccountApi from '../../api/src/account/api/AccountApi'
import TokenApi from '../../account_api/src/token/api/TokenApi'
// import {menus} from '../../router/index' 
import ERROR from '../../utils/error'
import { message } from 'ant-design-vue';
import { setSession } from '../../utils/cusMethod'
import { cusData } from '../../utils/cusData'
const accountApi = new AccountApi();
const tokenApi = new TokenApi();

const state = {
  user: {},
  menus: [],
  currentTeam: {
    companyList: []
  },
}

const mutations = {
  changeUser(state, {data}) {
    state.user = data
  },
  changeCurrentTeam(state, {data}) {
    state.currentTeam = data
  },
}

const actions = {
  loginByPwd: async ({commit, state}, {phoneNum, companyId, password}) => {
    // let resp = await accountApi.loginByPwd({phoneNum, companyId, password})
    let resp = await tokenApi.getTokenByPwd({app: 'CMS', phoneNum, password})
    console.log(resp)
    if(resp.type != 1){
      message.error('非教师用户')
      return
    }
    if(!resp.companyOrgList) {
      message.error('非集团用户')
      return
    }
    if(resp.companyOrgList.filter(item => {return item.id == 8}).length == 0) {
      message.error('非集团用户')
      return
    }
    console.log()
    let res = await accountApi.loginCompany({token: resp.token, companyId: 8})
    console.log(res)
    localStorage.setItem('token', res.token)
    resp.companyOrgList.forEach(companyOrg => {
      if(companyOrg.primary){
        resp.primaryCompanyId = companyOrg.id
      }
    })
    state.user = res
    // state.menus = menus
    return resp
  },
  loginByDingCode: async ({commit, state}, {code, companyId, clientType}) =>{
    try{
      let resp = await accountApi.loginByDingCode({code, companyId, clientType});
      state.user = resp
      // state.menus = menus
    }catch(e) {
      
    }
  },
  current: async ({commit, state}) =>{
    let resp = await accountApi.current();
    // resp.companyOrgList.forEach(companyOrg => {
    //   if(companyOrg.primary){
    //     resp.primaryCompanyId = companyOrg.id
    //   }
    // })
    localStorage.setItem('token', resp.token)
    state.user = resp
    // state.menus = menus
    return resp
    // try{
    //   let resp = await accountApi.current();
    //   resp.companyOrgList.forEach(companyOrg => {
    //     if(companyOrg.primary){
    //       resp.primaryCompanyId = companyOrg.id
    //     }
    //   })
    //   state.user = resp
    //   state.menus = menus
    //   return resp
    // }catch (e) {
    //   console.log(e)
    //   if(e.status == 401){
    //     window.location.href = '/cms/login'
    //   }
    // }
  },
  switchLoginTeam: async ({commit, state}, {teamId}) =>{
    let res = await accountApi.switchLoginTeam(teamId);
    commit('changeUser', {data: res})
    for(let team of res.teamList){
      if(team.currentLogin){
        commit('changeCurrentTeam', {data: team})
        return
      }
    }
  },
  switchLoginCompany: async ({ commit }, companyId) => {
    try {
      const res = await accountApi.switchLoginCompany(companyId)
      localStorage.setItem('token', res.token)
      commit('changeUser', { data: res })
      setSession(cusData.USERINFO, res)
      const cid =
        res.company && res.company.id != null ? res.company.id : companyId
      setSession(cusData.companyId, cid)
      return res
    } catch (e) {
      console.error(e)
      message.error((e && e.message) || '切换失败')
      throw e
    }
  },
  logout: async ({commit, state}) =>{
    let res = await accountApi.logout();
    window.location.href = '/cms/login'
  },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}